import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import {
  doInitForCreate,
  normalizeTimesheetFromApi,
  unwrapU3129LuTimesheetResultPayload,
  type U3129InitForCreateParams,
  type U3129Timesheet,
} from "./U3129Service";

/**
 * Initialisation serveur d’une feuille vide (`initForCreate`) — ne pas appeler `doInitForCreate` depuis les composants.
 */
export function useU3129InitForCreateHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const initForCreate = useCallback(
    async (params: U3129InitForCreateParams): Promise<U3129Timesheet | null> => {
      const response = await doInitForCreate(axios, params);
      const env = response.data as { result?: unknown; Result?: unknown } | undefined;
      const raw = unwrapU3129LuTimesheetResultPayload(env?.result ?? env?.Result);
      if (raw == null) return null;
      return normalizeTimesheetFromApi(raw);
    },
    [axios],
  );

  return { initForCreate };
}
